<template>
  <v-btn color="#db0812" :disabled="disabled" text small class="pl-0 text-cta" @click="$emit('click')">{{copy}}</v-btn>
</template>

<script>
export default {
  name: 'TextCta',

  props: {
    copy: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
